var map = {
	"./cutis/logo.png": 333,
	"./dev/logo.png": 886,
	"./indo/logo.png": 867,
	"./lf/logo.png": 615,
	"./lhekm/logo.png": 14,
	"./mitera/logo.png": 593,
	"./mosc/logo.png": 711,
	"./test/logo.png": 537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862;